import * as stylis from 'stylis';
import { EMPTY_ARRAY, EMPTY_OBJECT } from './empties';
import throwStyledError from './error';
import { phash, SEED } from './hash';
var AMP_REGEX = /&/g;
var COMMENT_REGEX = /^\s*\/\/.*$/gm;
/**
 * Takes an element and recurses through it's rules added the namespace to the start of each selector.
 * Takes into account media queries by recursing through child rules if they are present.
 */
function recursivelySetNamepace(compiled, namespace) {
    return compiled.map(function (rule) {
        if (rule.type === 'rule') {
            // add the namespace to the start
            rule.value = "".concat(namespace, " ").concat(rule.value);
            // add the namespace after each comma for subsequent selectors.
            // @ts-expect-error we target modern browsers but intentionally transpile to ES5 for speed
            rule.value = rule.value.replaceAll(',', ",".concat(namespace, " "));
            rule.props = rule.props.map(function (prop) {
                return "".concat(namespace, " ").concat(prop);
            });
        }
        if (Array.isArray(rule.children) && rule.type !== '@keyframes') {
            rule.children = recursivelySetNamepace(rule.children, namespace);
        }
        return rule;
    });
}
export default function createStylisInstance(_a) {
    var _b = _a === void 0 ? EMPTY_OBJECT : _a, _c = _b.options, options = _c === void 0 ? EMPTY_OBJECT : _c, _d = _b.plugins, plugins = _d === void 0 ? EMPTY_ARRAY : _d;
    var _componentId;
    var _selector;
    var _selectorRegexp;
    var selfReferenceReplacer = function (match, offset, string) {
        if (
        /**
         * We only want to refer to the static class directly in the following scenarios:
         *
         * 1. The selector is alone on the line `& { color: red; }`
         * 2. The selector is part of a self-reference selector `& + & { color: red; }`
         */
        string === _selector ||
            (string.startsWith(_selector) &&
                string.endsWith(_selector) &&
                string.replaceAll(_selector, '').length > 0)) {
            return ".".concat(_componentId);
        }
        return match;
    };
    /**
     * When writing a style like
     *
     * & + & {
     *   color: red;
     * }
     *
     * The second ampersand should be a reference to the static component class. stylis
     * has no knowledge of static class so we have to intelligently replace the base selector.
     *
     * https://github.com/thysultan/stylis.js/tree/v4.0.2#abstract-syntax-structure
     */
    var selfReferenceReplacementPlugin = function (element) {
        if (element.type === stylis.RULESET && element.value.includes('&')) {
            element.props[0] = element.props[0]
                // catch any hanging references that stylis missed
                .replace(AMP_REGEX, _selector)
                .replace(_selectorRegexp, selfReferenceReplacer);
        }
    };
    var middlewares = plugins.slice();
    middlewares.push(selfReferenceReplacementPlugin);
    /**
     * Enables automatic vendor-prefixing for styles.
     */
    if (options.prefix) {
        middlewares.push(stylis.prefixer);
    }
    middlewares.push(stylis.stringify);
    var stringifyRules = function (css, selector, 
    /**
     * This "prefix" referes to a _selector_ prefix.
     */
    prefix, componentId) {
        if (selector === void 0) { selector = ''; }
        if (prefix === void 0) { prefix = ''; }
        if (componentId === void 0) { componentId = '&'; }
        // stylis has no concept of state to be passed to plugins
        // but since JS is single-threaded, we can rely on that to ensure
        // these properties stay in sync with the current stylis run
        _componentId = componentId;
        _selector = selector;
        _selectorRegexp = new RegExp("\\".concat(_selector, "\\b"), 'g');
        var flatCSS = css.replace(COMMENT_REGEX, '');
        var compiled = stylis.compile(prefix || selector ? "".concat(prefix, " ").concat(selector, " { ").concat(flatCSS, " }") : flatCSS);
        if (options.namespace) {
            compiled = recursivelySetNamepace(compiled, options.namespace);
        }
        var stack = [];
        stylis.serialize(compiled, stylis.middleware(middlewares.concat(stylis.rulesheet(function (value) { return stack.push(value); }))));
        return stack;
    };
    stringifyRules.hash = plugins.length
        ? plugins
            .reduce(function (acc, plugin) {
            if (!plugin.name) {
                throwStyledError(15);
            }
            return phash(acc, plugin.name);
        }, SEED)
            .toString()
        : '';
    return stringifyRules;
}
//# sourceMappingURL=stylis.js.map